/* eslint-disable react/no-danger */
import React from 'react';
import appIcon from '../../../../static/img/picto-appstore.svg';
import playIcon from '../../../../static/img/picto-playstore.svg';

export default function SectionA({ content }) {
  return (
    <section className="section-a">
      {content && content.intro_video &&
        <video className="intro__video" autoPlay loop playsInline muted>
          <track kind="captions" />
          <source src={content.intro_video.source_url} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>}
      {content && <div className="intro__image" style={{ backgroundImage: `url(${content.intro_image.source_url})` }} />}
      <div className="container">
        {content &&
        <div className="intro">
          <div className="row">
            <div className="col-12 col-md-7">
              <div className="info">
                <h1 className="section-title" dangerouslySetInnerHTML={{ __html: content.intro_title }} />
                <div className="intro-subtitle" dangerouslySetInnerHTML={{ __html: content.intro_subtitle }} />

                <div className="intro-footer">
                  <p>{content.stores_title}</p>
                  <p>
                    <a target="_blank" rel="noopener noreferrer" href={content.intro_store_apple_url}>
                      <img src={appIcon} alt="" /> App Store
                    </a>
                    <a target="_blank" rel="noopener noreferrer" href={content.intro_store_google_url}>
                      <img src={playIcon} alt="" /> Google Play
                    </a>
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>}
      </div>
      <div className="intro-overlay" />
    </section>
  );
}
